import { render, staticRenderFns } from "./Annotation.vue?vue&type=template&id=2fb55c33&scoped=true&"
import script from "./Annotation.vue?vue&type=script&lang=js&"
export * from "./Annotation.vue?vue&type=script&lang=js&"
import style0 from "./Annotation.vue?vue&type=style&index=0&id=2fb55c33&prod&lang=scss&scoped=true&"
import style1 from "./Annotation.vue?vue&type=style&index=1&id=2fb55c33&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb55c33",
  null
  
)

export default component.exports